import { Media } from "../../types/media.interface";
import Image from "next/image";
import Link from "next/link";
interface RecentBlogCardProps {
  item: {
    id: number;
    slug: string;
    title: string;
    imageAlt: string;
    image: Media;
    publish: boolean;
  };
}


const RecentBlogCard: React.FC<RecentBlogCardProps> = ({ item }) => {
  return (
    <Link  href={item.slug}>
      <a className="w-full flex flex-col gap-1">
        <div className="w-full relative rounded-md aspect-video overflow-hidden">
            <Image
              height={200}
              width={300}
              layout="fill"
              src={
                "https://api.bungalowfinder.ca" + item.image.images.small.url
              }              alt={item.imageAlt}
            />
          </div>
          <h2 className="text-base font-medium capitalize">{item.title}</h2>
      </a>
    </Link>
  );
};
export default RecentBlogCard;
